import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Form, Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, FormGroup, Row, TabContent, TabPane } from "reactstrap";
import { Box, BoxProps, Container, Flex, Group, SimpleGrid, Text, Title } from "@mantine/core";
import classNames from "classnames";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { TitleContainer } from "@/components/HeaderContainer";
import { LightThemedButton, ThemedButton } from "@/components/ThemedButton";

import useLoginSession from "@/hooks/useLoginSession";

import generalApi from "@/services/general-api";

import { getErrorMessage } from "@/utilities/error";

import pm from "@/assets/img/Course/bus_meal/pm.png";

import { ReactComponent as CheckedIcon } from "./assets/checked.svg";
import styles from "./ModalMealSelection.module.scss";

function ModalMealSelection() {
	const { isLoginBySession } = useLoginSession();
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");
	const [dateString, setDateString] = useState("");
	const [mealDetails, setMealDetails] = useState({});
	const [selectedMeals, setSelectedMeals] = React.useState([]);
	const [meals, setMeals] = React.useState(undefined);
	let navigate = useNavigate();

	const MySwal = withReactContent(Swal);
	const location = useLocation();
	const learner_id = location.state?.learner_id;
	const course = location.state?.course;
	const status = location.state?.status;

	// State for current active Tab
	const [currentActiveTab, setCurrentActiveTab] = useState(0);

	// Toggle active state for Tab
	const toggle = (tab) => {
		if (currentActiveTab !== tab) setCurrentActiveTab(tab);
	};

	const {
		control,
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm();

	const getDate = (sessions) => {
		let sessionString = "";
		if (sessions && sessions.length > 0) {
			sessions.map((session) => {
				sessionString = sessionString.concat(
					`- ${moment(session.date, "YYYY-MM-DD").format("DD MMM YYYY")} (${moment(
						session.sessionFrom,
						"HH:mm:ss",
					).format("hh:mm a")} - ${moment(session.sessionto, "HH:mm:ss").format("hh:mm a")}) \n`,
				);
			});
		} else {
			return "-";
		}
		return sessionString;
	};

	useEffect(() => {
		generalApi.getMealDetails(learner_id).then(
			(response) => {
				setMeals(response.data.options || undefined);
				setMealDetails(response.data);
				setDateString(getDate(response.data.sessions));
				if (response.data && response.data.options.length > 0) {
					let selectedOptions = [];
					response.data.options.map((option) => {
						selectedOptions.push({
							date: option.date || "",
							food_id:
								option.Lunch && option.Lunch.selected
									? option.Lunch.selected.food_id.toString()
									: null,
							breakfast_food_id:
								option.Breakfast && option.Breakfast.selected
									? option.Breakfast.selected.food_id.toString()
									: null,
							dinner_food_id:
								option.Dinner && option.Dinner.selected
									? option.Dinner.selected.food_id.toString()
									: null,
							isLunch: option.Lunch ? true : false,
							isBreakfast: option.Breakfast ? true : false,
							isDinner: option.Dinner ? true : false,
							option_title:
								option.Lunch && option.Lunch.selected
									? option.Lunch.selected.food_type_option
									: null,
							breakfast_option_title:
								option.Breakfast && option.Breakfast.selected
									? option.Breakfast.selected.food_type_option
									: null,
							dinner_option_title:
								option.Dinner && option.Dinner.selected
									? option.Dinner.selected.food_type_option
									: null,
							breakfastfoodmenus:
								option.Breakfast && option.Breakfast.selected
									? option.Breakfast.selected.foodmenus
									: null,
							dinnerfoodmenus:
								option.Dinner && option.Dinner.selected ? option.Dinner.selected.foodmenus : null,
							foodmenus:
								option.Lunch && option.Lunch.selected ? option.Lunch.selected.foodmenus : null,
							option: option,
						});
					});
					setSelectedMeals(selectedOptions);
				}
			},
			(error) => {
				navigate("/course");
			},
		);
	}, []);

	const handleSaveMeal = (data) => {
		setLoading(true);
		var next_step = true;
		setMessage("");

		if (data.selections && data.selections.length > 0) {
			for (let i = 0; i < data.selections.length; i++) {
				if (
					mealDetails.options[i].Lunch !== null &&
					data.selections[i] &&
					data.selections[i].food_id == null
				) {
					next_step = false;
					setMessage("Lunch Selection for Day " + (i + 1) + " is required.");
					setCurrentActiveTab(i);
					setLoading(false);
					break;
				}
				if (
					mealDetails.options[i].Breakfast !== null &&
					data.selections[i] &&
					data.selections[i].breakfast_food_id == null
				) {
					next_step = false;
					setMessage("Breakfast Selection for Day " + (i + 1) + " is required.");
					setCurrentActiveTab(i);
					setLoading(false);
					break;
				}
				if (
					mealDetails.options[i].Dinner !== null &&
					data.selections[i] &&
					data.selections[i].dinner_food_id == null
				) {
					next_step = false;
					setMessage("Dinner Selection for Day " + (i + 1) + " is required.");
					setCurrentActiveTab(i);
					setLoading(false);
					break;
				}
			}

			if (next_step) {
				const request_selection = data.selections.filter((element) => {
					if (Object.keys(element).length !== 0) {
						return true;
					}
					return false;
				});
				generalApi
					.saveMeal(learner_id, request_selection, data.remarks)
					.then(
						(response) => {
							if (window.ReactNativeWebView) {
								window.ReactNativeWebView.postMessage(
									JSON.stringify({
										status: "success",
									}),
								);
								return;
							}

							// setLoading(false);
							navigate("/course/meal-success-page", {
								state: {
									data: {
										course: course,
										selection: request_selection,
										mealDetails: mealDetails,
										remark: data.remarks,
									},
								},
							});
							// MySwal.fire({
							// 	title: "Congratulations!",
							// 	html: <p>Meal Selection Update Successfully.</p>,
							// 	icon: "success",
							// 	// didOpen: () => {
							// 	// 	// `MySwal` is a subclass of `Swal` with all the same instance & static methods
							// 	// 	MySwal.showLoading();
							// 	// },
							// }).then(() => {
							// 	navigate("/course/course-details/", {
							// 		state: { data: course, status: status },
							// 	});
							// });
						},
						(error) => {
							setLoading(false);
							setMessage(getErrorMessage(error));
						},
					)
					.catch(() => {
						setLoading(false);
					});
			}
		}
	};

	const handlePopup = (displayMSG) => {
		MySwal.fire({
			title: "Unable to Proceed!",
			html: displayMSG,
			icon: "error",
			// icon: "warning",
			// didOpen: () => {
			// 	// `MySwal` is a subclass of `Swal` with all the same instance & static methods
			// 	MySwal.showLoading();
			// },
		});
	};

	const selectMeal = (dayIndex, mealIndex) => {
		let newSelectedMeals = [...selectedMeals];
		newSelectedMeals[dayIndex].food_id =
			(meals && meals[currentActiveTab].Lunch.food_options[mealIndex].food_id.toString()) || null;
		newSelectedMeals[dayIndex].option_title =
			(meals && meals[currentActiveTab].Lunch.food_options[mealIndex].food_type_option) || null;
		newSelectedMeals[dayIndex].foodmenus =
			(meals && meals[currentActiveTab].Lunch.food_options[mealIndex].foodmenus) || null;

		setSelectedMeals(newSelectedMeals);
	};

	const selectBreakfastMeal = (dayIndex, mealIndex) => {
		let newSelectedMeals = [...selectedMeals];
		newSelectedMeals[dayIndex].breakfast_food_id =
			(meals && meals[currentActiveTab].Breakfast.food_options[mealIndex].food_id.toString()) ||
			null;
		newSelectedMeals[dayIndex].breakfast_option_title =
			(meals && meals[currentActiveTab].Breakfast.food_options[mealIndex].food_type_option) || null;
		newSelectedMeals[dayIndex].breakfastfoodmenus =
			(meals && meals[currentActiveTab].Breakfast.food_options[mealIndex].foodmenus) || null;

		setSelectedMeals(newSelectedMeals);
	};

	const selectDinnerMeal = (dayIndex, mealIndex) => {
		let newSelectedMeals = [...selectedMeals];
		newSelectedMeals[dayIndex].dinner_food_id =
			(meals && meals[currentActiveTab].Dinner.food_options[mealIndex].food_id.toString()) || null;
		newSelectedMeals[dayIndex].dinner_option_title =
			(meals && meals[currentActiveTab].Dinner.food_options[mealIndex].food_type_option) || null;
		newSelectedMeals[dayIndex].dinnerfoodmenus =
			(meals && meals[currentActiveTab].Dinner.food_options[mealIndex].foodmenus) || null;

		setSelectedMeals(newSelectedMeals);
	};

	return (
		<Container>
			<TitleContainer>Meal Selection</TitleContainer>
			<div>
				<Card className="mt-4">
					<CardBody>
						<div>
							<p className="fs14 text-fca-dark">
								{
									"Please select your meal selection and indicate if you have any dietary requirements."
								}
							</p>
						</div>
						<hr></hr>
						<Form role="form" onSubmit={handleSubmit(handleSaveMeal)}>
							<div>
								<Row>
									<Col md="12" xl="6">
										<FormGroup>
											<label
												className="fs14 text-fca-dark font-weight-600"
												htmlFor="input-courseName">
												{"Course Name"}
											</label>
											<input
												className={"form-control "}
												defaultValue={mealDetails.course_title}
												disabled={true}
												id="input-courseName"
												type="text"
											/>
										</FormGroup>
									</Col>
									<Col md="12" xl="6">
										<FormGroup>
											<label
												className="fs14 text-fca-dark font-weight-600"
												htmlFor="input-learnerName">
												{"Learner Name"}
											</label>
											<input
												className={"form-control "}
												defaultValue={mealDetails.learner_name}
												disabled={true}
												id="input-learnerName"
												type="text"
											/>
										</FormGroup>
									</Col>
									<Col md="12" xl="12">
										<FormGroup>
											<label
												className="fs14 text-fca-dark font-weight-600"
												htmlFor="input-courseDate">
												{"Date"}
											</label>
											<textarea
												className={"form-control "}
												defaultValue={dateString}
												disabled={true}
												id="input-courseDate"
												type="text"
												rows="5"
											/>
										</FormGroup>
									</Col>
									<Col md="12" xl="12">
										<FormGroup>
											<label className="fs14 text-fca-dark font-weight-600" htmlFor="input-remarks">
												{"Food Allergy Remarks"}
											</label>
											<textarea
												className={"form-control " + (errors.remarks ? "is-invalid" : "")}
												id="input-remarks"
												defaultValue={mealDetails.food_remark}
												placeholder="Eg. Allergic to seafood"
												rows="5"
												{...register("remarks")}
											/>
										</FormGroup>
									</Col>
								</Row>
							</div>

							{mealDetails && mealDetails.options && mealDetails.options.length > 0 && (
								<div>
									<label className="fs14 text-fca-dark font-weight-600">
										{"Meal Selections *"}
									</label>

									<Group>
										{mealDetails.options.map((option, i) => (
											<>
												{currentActiveTab == i ? (
													<ThemedButton
														size="md"
														px={50}
														key={i}
														onClick={() => {
															toggle(i);
														}}>
														{`Day ${i + 1}`}
													</ThemedButton>
												) : (
													<LightThemedButton
														size="md"
														px={50}
														key={i}
														onClick={() => {
															toggle(i);
														}}>
														{`Day ${i + 1}`}
													</LightThemedButton>
												)}{" "}
											</>
										))}
									</Group>

									<Box px="10">
										<div className="meal-selection-tab-content-wrap">
											{mealDetails.options.map((day, day_index) => (
												<TabContent key={day_index} activeTab={currentActiveTab}>
													<TabPane tabId={day_index}>
														<div className="day-wrap mx--3 mt-5">
															<input
																type="hidden"
																defaultValue={day.date}
																{...register(`selections.${day_index}.date`)}></input>

															{/* Breakfast Section */}
															{day.Breakfast?.food_options?.length > 0 && (
																<Box mt={10}>
																	<Title order={5} mx={8}>
																		{day.Breakfast.alternative_display_name
																			? `${day.Breakfast.alternative_display_name}`
																			: "Breakfast "}
																		{"Selection (Please Select One)"}
																	</Title>
																	<SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} mt={2} pt={10}>
																		{day.Breakfast.food_options.map((food_option, j) => (
																			<SelectionBox isActive={currentActiveTab == day_index}>
																				<label key={j} className="d-block mx-2 mb-2">
																					<Controller
																						control={control}
																						name={`selections.${day_index}.breakfast_food_id`}
																						defaultValue={day.Breakfast.selected?.food_id}
																						render={({ field }) => (
																							<>
																								<input
																									type="radio"
																									name={`selections.${day_index}.breakfast_food_id`}
																									defaultChecked={
																										field.value === food_option.food_id
																									}
																									value={food_option.food_id}
																									onChange={() =>
																										field.onChange(food_option.food_id)
																									}
																								/>
																								<FoodOptionDisplay
																									food_option={food_option}
																									selected={field.value === food_option.food_id}
																								/>
																							</>
																						)}
																					/>
																				</label>
																			</SelectionBox>
																		))}
																	</SimpleGrid>
																</Box>
															)}

															{/* Lunch Section */}
															{day &&
																day.Lunch &&
																day.Lunch.food_options &&
																day.Lunch.food_options.length > 0 && (
																	<Box mt={10}>
																		<Title order={5} mx={8}>
																			{"Lunch"} {"Selection (Please Select One)"}
																		</Title>
																		<SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} mt={2} pt={10}>
																			{day.Lunch?.food_options?.map((food_option, j) => (
																				<SelectionBox isActive={currentActiveTab == day_index}>
																					<label key={j} className="d-block mx-2 mb-2">
																						<Controller
																							control={control}
																							name={`selections.${day_index}.food_id`}
																							defaultValue={day.Lunch.selected?.food_id}
																							render={({ field }) => (
																								<>
																									<input
																										type="radio"
																										name={`selections.${day_index}.food_id`}
																										defaultChecked={
																											field.value === food_option.food_id
																										}
																										value={food_option.food_id}
																										onChange={() =>
																											field.onChange(food_option.food_id)
																										}
																									/>
																									<FoodOptionDisplay
																										food_option={food_option}
																										selected={field.value === food_option.food_id}
																									/>
																								</>
																							)}
																						/>
																					</label>
																				</SelectionBox>
																			))}
																		</SimpleGrid>
																	</Box>
																)}

															{day["Afternoon Tea"]?.food_options?.length > 0 && (
																<Box mt={10} style={{ marginTop: "50px" }}>
																	<Title order={5} mx={8}>
																		{"Afternoon Tea Break"}
																	</Title>
																	<SelectionBox isActive={true}>
																		<label className="d-block mx-2 mb-2">
																			<input type="radio" defaultChecked={true} />
																			<FoodOptionDisplay
																				food_option={day["Afternoon Tea"].food_options[0]}
																				selected={true}
																			/>
																		</label>
																	</SelectionBox>
																</Box>
															)}

															{/* Dinner Section */}
															{day.Dinner?.food_options?.length > 0 && (
																<Box mt={10} style={{ marginTop: "50px" }}>
																	<Title order={5} mx={8}>
																		{"Dinner "}
																		{"Selection (Please Select One)"}
																	</Title>
																	<SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} mt={2} pt={10}>
																		{day.Dinner.food_options.map((food_option, j) => (
																			<SelectionBox isActive={currentActiveTab == day_index}>
																				<label key={j} className="d-block mx-2 mb-2">
																					<Controller
																						control={control}
																						name={`selections.${day_index}.dinner_food_id`}
																						defaultValue={day.Dinner.selected?.food_id}
																						render={({ field }) => (
																							<>
																								<input
																									type="radio"
																									name={`selections.${day_index}.dinner_food_id`}
																									defaultChecked={
																										field.value === food_option.food_id
																									}
																									value={food_option.food_id}
																									onChange={() =>
																										field.onChange(food_option.food_id)
																									}
																								/>
																								<FoodOptionDisplay
																									food_option={food_option}
																									selected={field.value === food_option.food_id}
																								/>
																							</>
																						)}
																					/>
																				</label>
																			</SelectionBox>
																		))}
																	</SimpleGrid>
																</Box>
															)}
														</div>
													</TabPane>
												</TabContent>
											))}
										</div>
									</Box>

									<div className="notes pt-4">
										{"*No egg, onion, garlic and mock meat for vegetarian selection."}
									</div>
								</div>
							)}

							<Row>
								{message && (
									<Col md="12" xl="12" className="mt-6">
										<div
											className="alert alert-danger"
											role="alert"
											dangerouslySetInnerHTML={{ __html: message }}></div>
									</Col>
								)}
								<Col md="12" xl="12" className="mt-6">
									<div className="flex mb-4">
										{!isLoginBySession && (
											<ThemedButton
												size="md"
												color="gray.2"
												mr={10}
												c="black"
												component={Link}
												to="/course/course-details/"
												state={{ data: course, status: status }}
												className="ml-auto">
												{"Back"}
											</ThemedButton>
										)}

										{/* {!course.cannot_select_food_reason ? (
										) : (
											<ThemedButton
												onClick={() => handlePopup(course.cannot_select_food_reason)}>
												{"Submit"}
											</ThemedButton>
											// <Button
											// 	className='btn-gradient opacity-6'
											// 	onClick={() => handlePopup(course.cannot_select_food_reason)}>
											// 	<span>{"Submit"}</span>
											// </Button>
										)} */}

										<ThemedButton type="submit" disabled={loading} size="md">
											{loading && <span className="spinner-border spinner-border-sm"></span>}
											{"Submit"}
										</ThemedButton>
									</div>
								</Col>
							</Row>
						</Form>
					</CardBody>
				</Card>
			</div>
		</Container>
	);
}

const SelectionBox = (props: { children: React.ReactNode; isActive: Boolean } & BoxProps) => {
	const { children, isActive, className, ...rest } = props;
	return (
		<Box className={classNames(styles.optionWrap, className)} {...rest}>
			{props.children}
		</Box>
	);
};

const FoodOptionDisplay = function ({ food_option, selected = false }) {
	return (
		<Box className={styles.optionBox}>
			<Title order={5} mb={10}>
				{food_option.food_type_option}
			</Title>

			<Box className={styles.optionContent} pos={"relative"} mih={200} bdrs={"5px"}>
				<Flex pos={"absolute"} top={10} right={10} align="center" justify="center">
					{selected ? (
						<CheckedIcon width={16} height={16} />
					) : (
						// : <CheckedEmptyIcon width={16} height={16} />
						<Box w={16} h={16} bdrs={"100%"} bd={"1.5px solid var(--mantine-color-gray-5)"} />
					)}
				</Flex>

				<ul className="list-unstyled">
					{food_option.foodmenus.map((food, k) => (
						<li key={k}>
							<div className="food_name">{`${food.food_name_en} (${food.food_name_cn})`}</div>
							{food.food_allergern && (
								<div className="food_allergern">{`Allergen: ${food.food_allergern}`}</div>
							)}
							<div className="food_ingredient">{food.food_ingredient}</div>
						</li>
					))}
				</ul>
			</Box>
		</Box>
	);
};

export default ModalMealSelection;
